import { apiList, apiGet, apiCreate, apiUpdate, apiDelete } from './apiClient';

export const getDevices = async (_params?: any) => apiList('devices');
export const getDeviceById = async (id: number | string) => apiGet('devices', id);
export const createDevice = async (data: any) => apiCreate('devices', data);
export const updateDevice = async (id: number | string, data: any) => apiUpdate('devices', id, data);
export const deleteDevice = async (id: number | string) => apiDelete('devices', id);
